import { jsx as _jsx } from "react/jsx-runtime";
import TranscriptsChatList from "src/features/transcripts/TranscriptsChatList";
const TranscriptsChatGroupedList = ({ groupedTranscripts }) => {
    return (groupedTranscripts.map((transcriptGroup, index) => {
        return _jsx(TranscriptsChatList, { transcripts: transcriptGroup, enableFaded: true }, index);
    }));
};
export default TranscriptsChatGroupedList;
